import React, { useEffect } from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import history from "constants/history";
import PrivateRoute from "./PrivateRoute";
import "../styles/App.scss";
import SignIn from "./SignIn/SignInPage";
import CreatePicture from "./CreatePicture/CreatePicture";
import JoinInPage from "./JoinIn/JoinInPage";
import Home from "./Home/Home";
import GeneralModal from "./General-UI/GlobalModals/GeneralModal";
import { useDispatch, useSelector } from "react-redux";
import { checkDeviceAndBrowser, selectGuestInfo } from "slices/generalSlice";
import AppDropper from "./AppDropper/AppDropper";
import DevicePermissionsModal from "./General-UI/GlobalModals/DevicePermissionsModal";
import ConnectionError from "./General-UI/GlobalModals/ConnectionError";
import "tippy.js/animations/shift-away.css";
import HelperScreen from "./HelpSlides/HelperScreen";
import { unloadCallFrame } from "slices/mediaServerSlice";
import PersonalSettings from "./Home/PersonalSettings/PersonalSettings";
import GuestView from "./Home/GuestView/GuestView";
export const APP_COMPONENT = "app-component";

const App = () => {
  const dispatch = useDispatch();
  const guestInfo = useSelector(selectGuestInfo);

  useEffect(() => {
    dispatch(checkDeviceAndBrowser());
    return () => unloadCallFrame();
  }, [dispatch]);
  return (
    <Router history={history}>
      <div id={APP_COMPONENT} className={`app`}>
        <AppDropper />
        <GeneralModal />
        <ConnectionError />
        <DevicePermissionsModal />
        <HelperScreen />
        <PersonalSettings />

        <Switch>
          <Route path="/signIn" exact component={SignIn} />
          <PrivateRoute path="/createPicture" exact component={CreatePicture} />
          <PrivateRoute
            path="/join/:code"
            exact
            component={guestInfo ? GuestView : JoinInPage}
          />
          <PrivateRoute path="/:node_id(home|\d{19})" component={Home} />
          <Redirect from="*" to="/home" />
        </Switch>
      </div>
    </Router>
  );
};

export default App;
